import it from './messages/it';
import en from './messages/en';
import de from './messages/de';
import fr from "./messages/fr";

export default {
    "it": it,
    "en": en,
    "de": de,
    "es": {},
    "fr": fr
}
